module.exports = __webpack_public_path__ + "assets/img/201.b5f9530b.png";